import { Mail, MapPin, Clock } from "lucide-react";
import { IMG } from "../lib/assets";

const info = [
  { icon: Mail, label: "Email", value: "tariniastrovastusolutions@gmail.com", href: "mailto:tariniastrovastusolutions@gmail.com", testid: "contact-email" },
  { icon: MapPin, label: "Location", value: "Powai, Mumbai 400076", href: null, testid: "contact-address" },
  { icon: Clock, label: "Hours", value: "Mon — Sat · 10:00 AM – 6:00 PM IST", href: null, testid: "contact-hours" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-32">
      {/* HEADER */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="overline mb-6">Begin the conversation</div>
          <h1 className="font-bodoni text-5xl sm:text-6xl lg:text-8xl font-light tracking-tighter leading-[0.95] max-w-5xl">
            Reach out. <span className="italic text-[#A67C00]">Privately.</span>
          </h1>
          <p className="mt-8 text-[#6B5F55] max-w-2xl text-lg">
            For booking the consultations — please send an email with your short details
            and contact number, and we shall connect with you personally. No forms,
            no gatekeepers — just a quiet, considered conversation.
          </p>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="divide-y divide-[#D4AF37]/15 b-gold">
              {info.map((item, i) => {
                const Inner = (
                  <div className="flex items-center gap-6 p-6 md:p-8 group" data-testid={item.testid}>
                    <div className="w-12 h-12 flex items-center justify-center border border-[#C9A227]/30 text-[#A67C00] shrink-0">
                      <item.icon size={18} />
                    </div>
                    <div className="flex-1">
                      <div className="overline text-[10px]">{item.label}</div>
                      <div className="font-bodoni text-xl md:text-2xl text-[#1E1A17] mt-1 group-hover:text-[#A67C00] transition-colors">
                        {item.value}
                      </div>
                    </div>
                  </div>
                );
                return item.href ? (
                  <a key={i} href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="block">
                    {Inner}
                  </a>
                ) : (
                  <div key={i}>{Inner}</div>
                );
              })}
            </div>

            <div className="mt-10 p-8 b-gold bg-white">
              <div className="overline mb-3">A note before you call</div>
              <p className="text-sm text-[#6B5F55] leading-relaxed">
                Please have your full birth details (date, exact time, place) and — if possible —
                a simple digital floor-plan layout of your home or office ready.
                This allows Divya to offer a meaningful discussion from the very first conversation.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative yantra-card overflow-hidden h-full min-h-[500px]">
              <img src={IMG.mumbaiSkyline} alt="Mumbai skyline" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#FBF7F0] via-[#FBF7F0]/50 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8">
                <div className="overline">Based in</div>
                <div className="font-bodoni text-5xl md:text-6xl text-[#1E1A17] mt-2">Mumbai</div>
                <div className="text-[#6B5F55] mt-3 max-w-sm text-sm">
                  Serving clients across India, Canada and Sydney — in-person by appointment,
                  or via video call.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
